$(document).ready(function(){

	// -- functions --
	const toggleDropdownState = function(el){
		el.parent('.dropdown').toggleClass('open');
		el.attr('aria-expanded', function (i, attr){
	    return attr == 'true' ? 'false' : 'true'
		});
		el.next().attr('tabindex', function (i, attr){
	    return attr == '-1' ? '0' : '-1'
		});		
	}

	// -- dropdown state --
	$('form .dropdown__toggle').on('click', function(e){
		toggleDropdownState($(this));
	});
	
	// -- click outside dropdown --
	$(document).mouseup(function(e){
    var container = $('form .dropdown');
    if (!container.is(e.target) && container.has(e.target).length === 0){
			$('.dropdown').removeClass('open');
			$('.dropdown__toggle').attr('aria-expanded', 'false');
			$('.dropdown__menu').attr('tabindex', '-1');
    }
	});

});